import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bca12f78")

_pushScopeId("data-v-bca12f78")
const _hoisted_1 = { class: "row no-gutters2" }
const _hoisted_2 = { class: "col-12 col-md-6 pb-15" }
const _hoisted_3 = { class: "order-field-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_8 = { class: "col-12 col-md-6 pb-15" }
const _hoisted_9 = { class: "order-field-title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_14 = { class: "col-12 pb-15" }
const _hoisted_15 = { class: "order-field-title" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_17 = { class: "col-12 col-md-6" }
const _hoisted_18 = { class: "order-field-title" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_20 = { class: "input-feedback" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_23 = { class: "input-text-length" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("/100 ")
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = { class: "order-field-title" }
const _hoisted_27 = { class: "input-text-length" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("/255 ")
const _hoisted_29 = { class: "col-12 col-md-6" }
const _hoisted_30 = { class: "order-field-title" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_32 = { class: "input-feedback" }
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_35 = { class: "input-text-length" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("/50 ")
const _hoisted_37 = { class: "col-12 col-md-6" }
const _hoisted_38 = { class: "order-field-title" }
const _hoisted_39 = { class: "input-feedback" }
const _hoisted_40 = { class: "input-text-length" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("/50 ")
const _hoisted_42 = { class: "col-12 col-md-6 pb-15" }
const _hoisted_43 = { class: "order-field-title" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_45 = { class: "invalid-feedback" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_47 = {
  key: 0,
  class: "novalid-input"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_49 = { class: "col-12 col-md-6 pb-15" }
const _hoisted_50 = {
  class: "order-field-title",
  style: {"opacity":"0.4"}
}
const _hoisted_51 = { class: "invalid-feedback" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "novalid-input"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('product.channel')), 1),
        _hoisted_4
      ]),
      _createVNode(_component_Multiselect, {
        disabled: _ctx.orderProductExist,
        class: [{ 'form-controll-multiselect': !_ctx.theModel.channelId }, "custom-multiselect-input"],
        options: _ctx.channels,
        label: "text",
        modelValue: _ctx.theModel.channelId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.theModel.channelId = $event)),
        canDeselect: false,
        valueProp: "id",
        required: "",
        searchable: false
      }, {
        caret: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "class", "options", "modelValue"]),
      _withDirectives(_createVNode("input", {
        type: "text",
        required: "",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.theModel.channelId = $event)),
        class: "form-control"
      }, null, 512), [
        [_vShow, false],
        [_vModelText, _ctx.theModel.channelId]
      ]),
      _createVNode("p", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("p", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('product.price-type')), 1),
        _hoisted_10
      ]),
      _createVNode(_component_Multiselect, {
        disabled: _ctx.orderProductExist,
        modelValue: _ctx.theModel.priceTypeId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.theModel.priceTypeId = $event)),
        value: 0,
        placeholder: "",
        valueProp: "id",
        trackBy: "text",
        label: "text",
        required: true,
        searchable: "true",
        options: _ctx.priceTypes,
        id: "wild-select",
        onChange: _ctx.getPriceCustomersOnPriceTypeChange,
        class: "custom-multiselect-input"
      }, {
        caret: _withId(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["disabled", "modelValue", "options", "onChange"]),
      _withDirectives(_createVNode("input", {
        type: "text",
        required: "",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.theModel.priceTypeId = $event)),
        class: "form-control"
      }, null, 512), [
        [_vShow, false],
        [_vModelText, _ctx.theModel.priceTypeId]
      ]),
      _createVNode("p", _hoisted_12, [
        _hoisted_13,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('cashier.label.business-client')), 1),
      _createVNode(_component_Multiselect, {
        disabled: _ctx.orderProductExist,
        modelValue: _ctx.theModel.businessClientId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.theModel.businessClientId = $event)),
        placeholder: "",
        valueProp: "id",
        trackBy: "name",
        label: "name",
        searchable: "true",
        options: _ctx.clients,
        allowEmpty: true,
        id: "wild-select",
        onChange: _ctx.onBussinessClientChange,
        class: "custom-multiselect-input"
      }, {
        caret: _withId(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["disabled", "modelValue", "options", "onChange"])
    ]),
    (_ctx.isGroupPrice)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.clientGroupName')), 1),
              _hoisted_19
            ]),
            _withDirectives(_createVNode("input", {
              type: "text",
              required: "",
              maxlength: "100",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.theModel.leadCustomer.groupName = $event)),
              class: "bookit-input w100"
            }, null, 512), [
              [_vModelText, _ctx.theModel.leadCustomer.groupName]
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("span", _hoisted_21, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
              ]),
              _createVNode("span", _hoisted_23, [
                _createVNode("span", {
                  class: {
                                'length-limit': _ctx.theModel.leadCustomer.groupName && _ctx.theModel.leadCustomer.groupName.length > 99
                            }
                }, _toDisplayString(_ctx.theModel.leadCustomer.groupName?.length ?? 0), 3),
                _hoisted_24
              ])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("p", _hoisted_26, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.customerPNR')), 1)
            ]),
            _withDirectives(_createVNode("input", {
              type: "text",
              maxlength: "255",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.theModel.leadCustomer.pnr = $event)),
              class: "bookit-input w100"
            }, null, 512), [
              [_vModelText, _ctx.theModel.leadCustomer.pnr]
            ]),
            _createVNode("span", _hoisted_27, [
              _createVNode("span", {
                class: { 'length-limit': _ctx.theModel.leadCustomer.pnr && _ctx.theModel.leadCustomer.pnr.length > 254 }
              }, _toDisplayString(_ctx.theModel.leadCustomer.pnr?.length ?? 0), 3),
              _hoisted_28
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_29, [
      _createVNode("p", _hoisted_30, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.clientFirstName')), 1),
        _hoisted_31
      ]),
      _withDirectives(_createVNode("input", {
        type: "text",
        required: "",
        maxlength: "50",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.theModel.leadCustomer.firstName = $event)),
        class: "bookit-input w100"
      }, null, 512), [
        [_vModelText, _ctx.theModel.leadCustomer.firstName]
      ]),
      _createVNode("div", _hoisted_32, [
        _createVNode("span", _hoisted_33, [
          _hoisted_34,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
        ]),
        _createVNode("span", _hoisted_35, [
          _createVNode("span", {
            class: { 'length-limit': _ctx.theModel.leadCustomer.firstName.length > 49 }
          }, _toDisplayString(_ctx.theModel.leadCustomer.firstName.length), 3),
          _hoisted_36
        ])
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("p", _hoisted_38, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.clientLastName')), 1)
      ]),
      _withDirectives(_createVNode("input", {
        type: "text",
        maxlength: "50",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.theModel.leadCustomer.lastName = $event)),
        class: "bookit-input w100"
      }, null, 512), [
        [_vModelText, _ctx.theModel.leadCustomer.lastName]
      ]),
      _createVNode("div", _hoisted_39, [
        _createVNode("span", _hoisted_40, [
          _createVNode("span", {
            class: { 'length-limit': _ctx.theModel.leadCustomer.lastName.length > 49 }
          }, _toDisplayString(_ctx.theModel.leadCustomer.lastName.length), 3),
          _hoisted_41
        ])
      ])
    ]),
    _createVNode("div", _hoisted_42, [
      _createVNode("p", _hoisted_43, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.mobileNumber')), 1),
        _hoisted_44
      ]),
      _withDirectives(_createVNode("input", {
        type: "text",
        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mobileNumberChanged())),
        required: "",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.theModel.leadCustomer.mobile = $event)),
        class: "bookit-input w100 mobile-input"
      }, null, 544), [
        [_vModelText, _ctx.theModel.leadCustomer.mobile]
      ]),
      _createVNode("span", _hoisted_45, [
        _hoisted_46,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
      ]),
      (_ctx.incorrectMobile)
        ? (_openBlock(), _createBlock("span", _hoisted_47, [
            _hoisted_48,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('novalid.input.mobile')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_49, [
      _createVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('newOrder.email')), 1),
      _withDirectives(_createVNode("input", {
        type: "text",
        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emailChanged())),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.theModel.leadCustomer.email = $event)),
        class: "bookit-input w100"
      }, null, 544), [
        [_vModelText, _ctx.theModel.leadCustomer.email]
      ]),
      _createVNode("span", _hoisted_51, [
        _hoisted_52,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
      ]),
      (_ctx.incorrectEmail)
        ? (_openBlock(), _createBlock("span", _hoisted_53, [
            _hoisted_54,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('novalid.input.email')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})